/**
 * Les colonnes du live du masteur (pur) : les seuils qui les ancrent et leurs largeurs. Lues par le live
 * (`<TutorLivePage>`) et par « Mes élèves » dans le cadre du live (`<TutorStudentsDeskPage>`), pour que les deux
 * gardent le même cadre quand l'un change.
 */

/** À partir de cette largeur de page, la colonne du champion est ancrée (en dessous, un tiroir). */
export const FEED_ANCHORED_FROM = 1024
/** À partir de cette largeur, la pellicule et la colonne du champion prennent leur largeur pleine. */
export const TUTOR_LIVE_WIDE_FROM = 1200
/** La pellicule, large puis resserrée. */
export const FILMSTRIP_WIDTH = { wide: 232, narrow: 208 }
/**
 * La colonne du champion, à largeur fixe (Wajih, 04/11 : « ni l'agrandir ni la rétrécir ») : 380 au large, comme
 * les maquettes ; 320 de 1 024 à 1 200, où le centre n'aurait plus la place de l'activité.
 */
export const FEED_WIDTH = { wide: 380, narrow: 320 }
